"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Dropdown = _interopRequireDefault(require("../../../Dropdown"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Throbber = _interopRequireDefault(require("../../../Throbber"));
var _dialer = require("../../../../icons-react/dialer");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledContent = _Dropdown["default"].StyledContent,
  StyledDropdownIcon = _Dropdown["default"].StyledDropdownIcon;
var DepartmentsDropdown = /*#__PURE__*/function (_React$PureComponent) {
  function DepartmentsDropdown(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, DepartmentsDropdown);
    _this = _callSuper(this, DepartmentsDropdown, [props]);
    _this.state = {
      isOpen: false
    };
    _this.handleToggleOpen = _this.handleToggleOpen.bind(_this);
    _this.departmentRenderer = _this.departmentRenderer.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(DepartmentsDropdown, _React$PureComponent);
  return (0, _createClass2["default"])(DepartmentsDropdown, [{
    key: "handleToggleOpen",
    value: function handleToggleOpen(isOpen) {
      var onToggle = this.props.onToggle;
      this.setState({
        isOpen: isOpen
      });
      onToggle({
        isOpen: isOpen
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref) {
      var currentTarget = _ref.currentTarget;
      var onChange = this.props.onChange;
      this.setState({
        isOpen: false
      });
      onChange({
        queueId: currentTarget.dataset.id
      });
    }
  }, {
    key: "departmentRenderer",
    value: function departmentRenderer() {
      var _this2 = this;
      var departments = this.props.departments;
      if (!departments) {
        return /*#__PURE__*/_react["default"].createElement(StyledThrobber, {
          size: 16,
          color: "#262729"
        });
      }
      if (departments.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(StyledEmpty, null, "\u041D\u0435\u0442 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043E\u0442\u0434\u0435\u043B\u043E\u0432!");
      }
      return departments.map(function (department) {
        var id = department.id,
          svg = department.svg,
          value = department.value,
          isReserve = department.isReserve;
        return /*#__PURE__*/_react["default"].createElement(StyledDepartment, {
          key: id,
          "data-id": id,
          onClick: _this2.handleChange
        }, svg && /*#__PURE__*/_react["default"].createElement(StyledImage, null, svg), isReserve && /*#__PURE__*/_react["default"].createElement(StyledReserve, null, "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435"), /*#__PURE__*/_react["default"].createElement(StyledName, null, value));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement(StyledDepartmentsDropdown, (0, _extends2["default"])({}, this.props, {
        headRenderer: DepartmentsDropdown.button(),
        contentRenderer: this.departmentRenderer(),
        onToggle: this.handleToggleOpen,
        open: isOpen
      }));
    }
  }], [{
    key: "button",
    value: function button() {
      return /*#__PURE__*/_react["default"].createElement(StyledLabel, null, /*#__PURE__*/_react["default"].createElement(StyledTransferIcon, null), "\u041F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u043D\u0430 \u043E\u0442\u0434\u0435\u043B");
    }
  }]);
}(_react["default"].PureComponent);
DepartmentsDropdown.propTypes = {
  className: _propTypes["default"].string,
  departments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    svg: _propTypes["default"].object,
    isReserve: _propTypes["default"].bool,
    value: _propTypes["default"].string.isRequired
  })).isRequired,
  onToggle: _propTypes["default"].func,
  onChange: _propTypes["default"].func
};
DepartmentsDropdown.defaultProps = {
  className: '',
  onToggle: Function.prototype,
  onChange: Function.prototype
};
var StyledDepartmentsDropdown = (0, _styledComponents["default"])(_Dropdown["default"]).withConfig({
  displayName: "DepartmentsDropdown__StyledDepartmentsDropdown",
  componentId: "sc-ziwpox-0"
})(["color:#fff;font-size:13px;border-radius:4px;border:solid 1px #919499;background-color:#262729;", "{width:423px;flex-wrap:wrap;}", "{margin:1px 8px 0 0;}"], StyledContent, StyledDropdownIcon);
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "DepartmentsDropdown__StyledLabel",
  componentId: "sc-ziwpox-1"
})(["color:#fff;display:flex;padding:10px 8px;white-space:nowrap;"]);
var StyledTransferIcon = (0, _styledComponents["default"])(_dialer.Transfer).withConfig({
  displayName: "DepartmentsDropdown__StyledTransferIcon",
  componentId: "sc-ziwpox-2"
})(["width:23px;height:19px;margin-right:7px;path{stroke:white;}"]);
var StyledDepartment = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "DepartmentsDropdown__StyledDepartment",
  componentId: "sc-ziwpox-3"
})(["border:none;margin:2px;align-items:center;cursor:pointer;display:flex;flex-direction:column;height:133px;position:relative;width:130px;flex-basis:130px;flex-grow:1;justify-content:flex-start;"]);
var StyledImage = _styledComponents["default"].div.withConfig({
  displayName: "DepartmentsDropdown__StyledImage",
  componentId: "sc-ziwpox-4"
})(["align-items:center;display:flex;height:53px;position:absolute;top:19px;"]);
var StyledName = _styledComponents["default"].span.withConfig({
  displayName: "DepartmentsDropdown__StyledName",
  componentId: "sc-ziwpox-5"
})(["color:#17181a;font-size:14px;position:absolute;top:100px;"]);
var StyledReserve = _styledComponents["default"].span.withConfig({
  displayName: "DepartmentsDropdown__StyledReserve",
  componentId: "sc-ziwpox-6"
})(["color:#4d4d4d;font-size:10px;position:absolute;text-transform:uppercase;top:85px;"]);
var StyledThrobber = (0, _styledComponents["default"])(_Throbber["default"]).withConfig({
  displayName: "DepartmentsDropdown__StyledThrobber",
  componentId: "sc-ziwpox-7"
})(["padding:35px 0;position:relative;"]);
var StyledEmpty = _styledComponents["default"].div.withConfig({
  displayName: "DepartmentsDropdown__StyledEmpty",
  componentId: "sc-ziwpox-8"
})(["width:100%;color:black;font-size:14px;line-height:70px;text-align:center;"]);
var _default = exports["default"] = DepartmentsDropdown;